module.exports = __webpack_public_path__ + "static/post1-6be9f3cfed100b4fdc60cedf2d2ef2d9.png";